import React from 'react';
import ReactDom from 'react-dom';

import App from './App';

// eslint-disable-next-line no-undef,react/jsx-filename-extension
ReactDom.render(<App />, document.getElementById('root'));
